import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import SpotahomeGuaranteeCircledIcon from '../../icons/SpotahomeGuaranteeCircledIcon';
import Feature from '../Feature';
import { GUARANTEE_FEATURE } from '../featureList';

const SpotahomeGuaranteeFeature = ({ collapsed, onCollapsedChange }) => {
  return (
    <Feature
      featureName={GUARANTEE_FEATURE}
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      renderBody={() => trans('property_show.book_now_card.guarantee.body')}
      renderIcon={() => <SpotahomeGuaranteeCircledIcon theme="dark" />}
      headerKey="property_show.book_now_card.guarantee"
    />
  );
};

SpotahomeGuaranteeFeature.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired
};

export default SpotahomeGuaranteeFeature;
